export default __webpack_public_path__ + "static/media/Non_veg_dot_Icon.d975d1f9.svg";